import { lists_type, args_type } from "./interfaces";

// 注意事項：
// 1. 只能用 ES6 以下語法 (不能使用 async, await, spread operator(...))

declare const lists: lists_type;
declare const get_db: (db_name: string, list: { url: string; kind?: string }[] | undefined) => Promise<any>;
declare const self: { db_version: { [key: string]: number }; db_disabled: boolean };
declare const close: Function;
declare const http_get_batch: (
  list: { url: string; kind: string; no_info?: boolean }[],
  page: string,
  hostname: string,
  role: string,
  datacenter_name: string,
  cluster_name?: string,
  workspace_name?: string,
  namespace_name?: string,
  subscription_id?: string,
  unit_provide?: string
) => Promise<unknown>;
declare const http_request_func: (args: args_type) => void;

// Web Worker 主函數部分
// 所有變數只能在這裡面宣告
// 匯入任何程式碼需用 importScripts，無法用 import

export default function httpWorker(_args: any): void {
  try {
    importScripts("core-js/es/promise");
  } catch (err) {}

  // 宣告接收到訊息時要做的事
  onmessage = (event: MessageEvent): void => {
    // ███╗   ███╗ █████╗ ██╗███╗   ██╗
    // ████╗ ████║██╔══██╗██║████╗  ██║
    // ██╔████╔██║███████║██║██╔██╗ ██║
    // ██║╚██╔╝██║██╔══██║██║██║╚██╗██║
    // ██║ ╚═╝ ██║██║  ██║██║██║ ╚████║
    // ╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝
    // 主             程             式
    const args: args_type = JSON.parse(event.data);
    self.db_version = {};
    self.db_disabled = false;
    get_db("data_version", [{ url: "version" }])
      .then((version: string[]) => {
        version[0] && (self.db_version["data"] = Number(version[0]));
      })
      .finally(() => {
        // http_get 部分
        let list = lists[args.func_name];

        if (list) {
          const { func_name, origin, role, datacenter_name, cluster_name, workspace_name, namespace_name, subscription_id, unit_provide }: args_type = args;
          // http_get 部分
          // 於讀寫 IndexedDB 結束後關閉 Web Worker
          http_get_batch(list, func_name, origin, role, datacenter_name, cluster_name, workspace_name, namespace_name, subscription_id, unit_provide).then(
            () => {
              setTimeout(() => {
                close();
              }, 0); // 結束 Worker
            }
          );
        } else {
          // http_request 部分
          http_request_func(args);
        }
      });
  };
}
